import { useEffect, useState } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'

/** El `window.prompt` con uno o varios campos, y sin dejar enviar un campo obligatorio vacío. */
export default function DialogoDatos({ abierto, opciones, onCerrar, onEnviar }) {
  const campos = opciones.campos || []
  const [valores, setValores] = useState({})
  useEffect(() => { if (abierto) setValores({}) }, [abierto])
  const faltan = campos.some((c) => c.obligatorio !== false && !String(valores[c.clave] || '').trim())

  return (
    <Dialog open={abierto} onOpenChange={(v) => !v && onCerrar()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{opciones.titulo}</DialogTitle>
          {opciones.descripcion && (
            <DialogDescription className="whitespace-pre-line">{opciones.descripcion}</DialogDescription>
          )}
        </DialogHeader>
        <form
          id="dialogo-datos"
          className="space-y-3"
          onSubmit={(e) => { e.preventDefault(); if (!faltan) onEnviar(valores) }}
        >
          {campos.map((c, i) => (
            <div key={c.clave} className="space-y-1.5">
              <Label htmlFor={`dd-${c.clave}`}>{c.etiqueta}</Label>
              {c.multilinea ? (
                <Textarea id={`dd-${c.clave}`} rows={4} autoFocus={i === 0} value={valores[c.clave] || ''}
                  onChange={(e) => setValores((v) => ({ ...v, [c.clave]: e.target.value }))} />
              ) : (
                <Input id={`dd-${c.clave}`} type={c.tipo || 'text'} autoFocus={i === 0} autoComplete="off" value={valores[c.clave] || ''}
                  onChange={(e) => setValores((v) => ({ ...v, [c.clave]: e.target.value }))} />
              )}
            </div>
          ))}
        </form>
        <DialogFooter className="gap-2 sm:gap-2">
          <Button variant="outline" onClick={onCerrar}>{opciones.textoCancelar || 'Cancelar'}</Button>
          <Button type="submit" form="dialogo-datos" disabled={faltan}>{opciones.textoConfirmar || 'Enviar'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
